import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "v-management" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "year" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "shift" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "filter" }
const _hoisted_13 = { class: "icon" }
const _hoisted_14 = { class: "number" }
const _hoisted_15 = { class: "table" }
const _hoisted_16 = { class: "belt" }
const _hoisted_17 = { colspan: "12" }
const _hoisted_18 = { class: "stats" }
const _hoisted_19 = { class: "capsule" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "capsule" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "capsule" }
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "capsule" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "capsule" }
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "rating__cell" }
const _hoisted_30 = { class: "number" }
const _hoisted_31 = { class: "action" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "tabs" }
const _hoisted_34 = { class: "name" }
const _hoisted_35 = {
  key: 0,
  class: "salary"
}
const _hoisted_36 = { class: "salary__footer" }
const _hoisted_37 = {
  key: 1,
  class: "absent"
}
const _hoisted_38 = { class: "absent__date action" }
const _hoisted_39 = { class: "input" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "absent__comment" }
const _hoisted_42 = { class: "absent__add" }
const _hoisted_43 = { class: "absent__footer" }
const _hoisted_44 = {
  key: 2,
  class: "rating"
}
const _hoisted_45 = { class: "action" }
const _hoisted_46 = { class: "action__rating" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "action" }
const _hoisted_49 = { class: "action__rating" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "action" }
const _hoisted_52 = { class: "action__rating" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  style: {"margin-bottom":"12px"},
  class: "action"
}
const _hoisted_55 = { class: "action__rating" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "rating__footer" }
const _hoisted_58 = { class: "advance__action" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]

import { useManagementStore } from "@/features/management/management.store";
import { computed, onMounted, ref, watch } from "vue";
import {
  Plus,
  ChevronLeft,
  ChevronRight,
  Pencil02,
  SearchMd,
  Trash01,
  Wallet04,
  XClose,
  Check,
} from "utruckin-icons";
import { IShiftTemplate } from "@/features/shifts/shifts.types";
import { useShiftStore } from "@/features/shifts/shifts.store";
import CommonModal from "@/components/common/CommonModal.vue";
import CustomTab from "@/components/custom/CustomTab.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import { DateTime } from "luxon";
import {
  IUpdateAdvancePayload,
  IUpdateBonusPayload,
  IUpdateSalaryPayload,
} from "@/features/management/management.types";
import { useNotification } from "@/utils/notification";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import { toRaw } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagementView',
  setup(__props) {

const managementStore = useManagementStore();
const shiftStore = useShiftStore();

const { pushNotification } = useNotification();

const search = ref<string>("");
let searchTimer: ReturnType<typeof setTimeout> | null = null;

const loading = ref<boolean>(false);
const list = ref<any[]>([]);
const summary = ref<any>();

const shifts = ref<IShiftTemplate[]>([]);
const shiftLoading = ref(false);

const isModalVisible = ref<boolean>(false);
const modalItem = ref<any>();
const oldModalItem = ref<any>();
const modalLoading = ref<boolean>(false);

const numberAdvanceRequests = ref<number>(0);
const isAdvanceModalVisible = ref<boolean>(false);
const advanceModalItems = ref<any>();
const advanceModalLoading = ref<boolean>(false);

const activeTab = ref<number>(0);
const tabs = [
  { label: "Salary", value: 0 },
  { label: "Absent", value: 1 },
  { label: "Rating", value: 2 },
];

const timeliness_score = ref<number>(1);
const coverage_score = ref<number>(1);
const team_score = ref<number>(1);
const no_shows_score = ref<number>(1);
const ratingComment = ref<string>("");

const absentDays = ref<any[]>([]);
const oldAbsentDays = ref<any[]>([]);

const currentShiftIndex = ref<number>(0);
const shiftItems = computed(() => {
  let result = shifts.value.map((s) => ({
    value: String(s.id),
    name: s.title,
  }));
  result.unshift({ value: "", name: "All shift" });

  return result;
});

const currentShiftItem = computed(
  () => shiftItems.value[currentShiftIndex.value % shiftItems.value.length]
);

const getList = async () => {
  await managementStore.getHrList(loading, (res: any) => {
    if (res) {
      list.value = res.items;
      summary.value = res.summary;
    }
  });
};

const getShifts = async () => {
  [shifts.value] = await Promise.all([shiftStore.getShifts(shiftLoading)]);
};

const previousMonth = () => {
  managementStore.now = managementStore.now?.minus({ months: 1 });
};

const nextMonth = () => {
  managementStore.now = managementStore.now?.plus({ months: 1 });
};

const selectItem = async (item: any) => {
  await managementStore.getUserDetail(
    modalLoading,
    item.user_id,
    {
      year: managementStore.managementFilter.year,
      month: managementStore.managementFilter.month,
    },
    (data: any) => {
      isModalVisible.value = true;
      modalItem.value = item;
      oldModalItem.value = { ...item };

      if (data.ratings.length) {
        timeliness_score.value = data.ratings[0].timeliness_score;
        coverage_score.value = data.ratings[0].coverage_score;
        team_score.value = data.ratings[0].team_score;
        no_shows_score.value = data.ratings[0].no_shows_score;
        ratingComment.value = data.ratings[0].comment;
      }

      if (data.extra_offs.length) {
        absentDays.value = data.extra_offs;
        oldAbsentDays.value = structuredClone(toRaw(absentDays.value));
      }
    }
  );
};

const closeModal = () => {
  isModalVisible.value = false;
  modalItem.value = undefined;
  oldAbsentDays.value = [];
  absentDays.value = [];

  timeliness_score.value = 1;
  coverage_score.value = 1;
  team_score.value = 1;
  no_shows_score.value = 1;
  ratingComment.value = "";
};

const saveSalary = async () => {
  if (!modalItem.value || modalLoading.value) return;

  const isSalaryChanged =
    modalItem.value.salary_payable !== oldModalItem.value.salary_payable;
  const isBonusChanged =
    modalItem.value.bonus_total !== oldModalItem.value.bonus_total;
  const isAdvanceChanged =
    modalItem.value.advance_paid_total !==
    oldModalItem.value.advance_paid_total;

  const todayDate = DateTime.now().toFormat("yyyy-MM-dd");

  const payloadSalary: IUpdateSalaryPayload = {
    new_monthly_wage: modalItem.value.salary_payable,
    effective_date: todayDate,
    reason: "no reason",
  };

  const payloadBonus: IUpdateBonusPayload = {
    amount: modalItem.value.bonus_total,
    currency: "USD",
    starts_on: todayDate,
    ends_on: todayDate,
    reason: "no reason",
  };

  const payloadAdvance: IUpdateAdvancePayload = {
    advance_month: todayDate,
    amount: modalItem.value.advance_paid_total,
    currency: "USD",
    reason: "no reason",
  };

  await Promise.all([
    isSalaryChanged
      ? managementStore.updateSalary(
          modalLoading,
          modalItem.value.user_id,
          payloadSalary,
          (res: any) => {
            if (res) {
              pushNotification("Successfully updated salary", "success");
            }
          }
        )
      : "",

    isBonusChanged
      ? managementStore.updateBonus(
          modalLoading,
          modalItem.value.user_id,
          payloadBonus,
          (res: any) => {
            if (res) {
              pushNotification("Successfully updated bonus", "success");
            }
          }
        )
      : "",

    isAdvanceChanged
      ? managementStore.updateAdvance(
          modalLoading,
          modalItem.value.user_id,
          payloadAdvance,
          (res: any) => {
            if (res) {
              pushNotification("Successfully updated advance", "success");
            }
          }
        )
      : "",
  ]);

  closeModal();
};

const prev = () => {
  currentShiftIndex.value =
    (currentShiftIndex.value - 1 + shiftItems.value.length) %
    shiftItems.value.length;
};

const next = () => {
  currentShiftIndex.value++;
};

const setTimelinessScore = (value: number) => {
  timeliness_score.value = value;
};

const setCoverageScore = (value: number) => {
  coverage_score.value = value;
};

const setTeamScore = (value: number) => {
  team_score.value = value;
};

const setNoShowsScore = (value: number) => {
  no_shows_score.value = value;
};

const saveRating = async () => {
  if (!modalItem.value || modalLoading.value) return;

  const todayDate = DateTime.now().toFormat("yyyy-MM-dd");

  await managementStore.updateRating(
    modalLoading,
    modalItem.value.user_id,
    {
      comment: ratingComment.value,
      rating_month: todayDate,
      coverage_score: coverage_score.value,
      no_shows_score: no_shows_score.value,
      team_score: team_score.value,
      timeliness_score: timeliness_score.value,
    },
    async (res: any) => {
      if (res) {
        pushNotification("Successfully updated rating", "success");
        closeModal();
        await getList();
        await getAdvanceRequests();
      }
    }
  );
};

const saveAbsent = async () => {
  if (!modalItem.value || modalLoading.value) return;

  for (const item of absentDays.value) {
    if (item.id) {
      const obj2 = oldAbsentDays.value.find((obj) => obj.id == item.id);

      if (obj2 && JSON.stringify(item) !== JSON.stringify(obj2)) {
        await managementStore.updateOff(
          modalLoading,
          modalItem.value.user_id,
          item.id,
          {
            affects_rating: item.affects_rating,
            comment: item.comment,
            is_paid: item.is_paid,
            off_date: item.off_date,
            reason: item.reason,
            reason_code: item.reason_code,
          },
          (res: any) => {
            if (res) {
              pushNotification("Successfully updated", "success");
            }
          }
        );
      }
    } else {
      if (item.off_date) {
        await managementStore.createOff(
          modalLoading,
          modalItem.value.user_id,
          {
            affects_rating: true,
            comment: item.comment,
            is_paid: false,
            off_date: item.off_date,
            reason: "string",
            reason_code: "string",
          },
          (res: any) => {
            if (res) {
              pushNotification("Successfully created", "success");
            }
          }
        );
      }
    }
  }
  await getList();
  await getAdvanceRequests();
};

const addExtraOff = () => {
  absentDays.value.push({
    off_date: "",
    comment: "",
  });
};

const deleteAbsentDay = async (index: number, item: any) => {
  if (item.id) {
    console.log(item);
    await managementStore.deleteOff(
      modalLoading,
      item.user_id,
      item.id,
      (data: any) => {
        if (!data) {
          return;
        } else {
          closeModal();
          pushNotification("Successfully deleted", "success");
        }
      }
    );
  } else {
    absentDays.value.splice(index, 1);
  }
};

const getAdvanceRequests = async () => {
  await managementStore.getAdvanceRequestsList(loading, (res: any) => {
    if (res) {
      numberAdvanceRequests.value = res.total;
      advanceModalItems.value = res.items;
    }
  });
};

const openAdvanceModal = () => {
  isAdvanceModalVisible.value = true;
  advanceModalLoading.value = false;
};

const closeAdvanceModal = () => {
  isAdvanceModalVisible.value = false;
  advanceModalLoading.value = false;
};

const rejectRequest = async (item: any) => {
  await managementStore.rejectAdvance(
    advanceModalLoading,
    item.user_id,
    item.id,
    async (res: any) => {
      if (res) {
        pushNotification("Successfully rejected", "success");
        closeAdvanceModal();
        await getList();
        await getAdvanceRequests();
      }
    }
  );
};

const approveRequest = async (item: any) => {
  await managementStore.approveAdvance(
    advanceModalLoading,
    item.user_id,
    item.id,
    async (res: any) => {
      if (res) {
        pushNotification("Successfully aproved", "success");
        closeAdvanceModal();
        await getList();
        await getAdvanceRequests();
      }
    }
  );
};

function datepickerToUtcDateOnly(d: any) {
  return d
    ? DateTime.fromISO(d, {
        zone: "utc",
      })
        .setZone("America/New_York")
        .toFormat("MMM d, HH:mm")
    : "-";
}

onMounted(async () => {
  await getList();
  await getShifts();
  await getAdvanceRequests();
});

watch(
  () => managementStore.now,
  (date) => {
    managementStore.managementFilter.year = date.year;
    managementStore.managementFilter.month = date.month;
    getList();
  },
  { deep: true }
);

watch(
  () => currentShiftItem.value.value,
  (val, oldVal) => {
    if (val === oldVal) return;
    managementStore.managementFilter.shift_template_id = val ? +val : null;
    getList();
  }
);

watch(
  () => search.value,
  async (val) => {
    if (loading.value) return;
    if (searchTimer) clearTimeout(searchTimer);
    searchTimer = setTimeout(async () => {
      managementStore.managementFilter.q = val;
      await getList();
    }, 400);
  }
);

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "left",
            onClick: previousMonth
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ChevronLeft), { size: 14 })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(managementStore).now?.toFormat("LLL yyyy")), 1),
          _createElementVNode("div", {
            class: "right",
            onClick: nextMonth
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_unref(ChevronRight), { size: 14 })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "left",
            onClick: prev
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(ChevronLeft), { size: 14 })
            ])
          ]),
          _createElementVNode("div", _hoisted_10, _toDisplayString(currentShiftItem.value.name), 1),
          _createElementVNode("div", {
            class: "right",
            onClick: next
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(ChevronRight), { size: 14 })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(CommonSearch, {
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          icon: _unref(SearchMd),
          placeholder: 'Search',
          clearable: ""
        }, null, 8, ["modelValue", "icon"]),
        _createElementVNode("div", {
          class: "advance",
          onClick: openAdvanceModal
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(Wallet04), { size: 20 })
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "Advance", -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(numberAdvanceRequests.value), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("table", null, [
        _cache[15] || (_cache[15] = _createElementVNode("colgroup", null, [
          _createElementVNode("col", { style: {"width":"1%"} }),
          _createElementVNode("col", { style: {"width":"19%"} }),
          _createElementVNode("col", { style: {"width":"7%"} }),
          _createElementVNode("col", { style: {"width":"12%"} }),
          _createElementVNode("col", { style: {"width":"10%"} }),
          _createElementVNode("col", { style: {"width":"12%"} }),
          _createElementVNode("col", { style: {"width":"8%"} }),
          _createElementVNode("col", { style: {"width":"6%"} }),
          _createElementVNode("col", { style: {"width":"6%"} }),
          _createElementVNode("col", { style: {"width":"6%"} }),
          _createElementVNode("col", { style: {"width":"10%"} }),
          _createElementVNode("col", { style: {"width":"4%"} })
        ], -1)),
        _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "No"),
            _createElementVNode("th", null, "Name"),
            _createElementVNode("th", null, "Position"),
            _createElementVNode("th", null, "Rating"),
            _createElementVNode("th", null, "Hire date"),
            _createElementVNode("th", null, "Last salary increase"),
            _createElementVNode("th", null, "Current salary"),
            _createElementVNode("th", null, "Advance"),
            _createElementVNode("th", null, "Bonus"),
            _createElementVNode("th", null, "Salary"),
            _createElementVNode("th", null, "Absent days"),
            _createElementVNode("th", null, "Actions")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", _hoisted_16, [
            _createElementVNode("td", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label" }, "Users", -1)),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(summary.value?.users_total), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "Paid employees", -1)),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(summary.value?.paid_employees), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label" }, "Total advance", -1)),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(summary.value?.total_advance), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label" }, "Total bonus", -1)),
                  _createElementVNode("div", _hoisted_26, _toDisplayString(summary.value?.total_bonus), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label" }, "Total salary", -1)),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(summary.value?.total_salary), 1)
                ])
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.role), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(item.rating ? item.rating : 0), 1),
                  _createElementVNode("div", {
                    class: "stars",
                    style: _normalizeStyle({ '--rating': item.rating ? item.rating : 0 })
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("div", { class: "stars-bg" }, "★★★★★", -1),
                    _createElementVNode("div", { class: "stars-fg" }, "★★★★★", -1)
                  ]))], 4)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(item.hire_duration_label || "-"), 1),
              _createElementVNode("td", null, _toDisplayString(item.last_salary_increase_label || "-"), 1),
              _createElementVNode("td", null, "$" + _toDisplayString(item.current_salary || "0"), 1),
              _createElementVNode("td", null, "$" + _toDisplayString(item.advance_paid_total || "0"), 1),
              _createElementVNode("td", null, "$" + _toDisplayString(item.bonus_total || "0"), 1),
              _createElementVNode("td", null, "$" + _toDisplayString(item.salary_payable || "0"), 1),
              _createElementVNode("td", null, _toDisplayString(item.absent_days_label || "-"), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "icon",
                    onClick: ($event: any) => (selectItem(item))
                  }, [
                    _createVNode(_unref(Pencil02), { size: 16 })
                  ], 8, _hoisted_32)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(CommonModal, {
      modelValue: isModalVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isModalVisible).value = $event)),
      title: "Edit user info",
      onClose: closeModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createVNode(CustomTab, {
            tabs: tabs,
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_34, _toDisplayString(modalItem.value.name), 1),
        (activeTab.value == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createVNode(CommonInput, {
                label: "Salary",
                modelValue: modalItem.value.salary_payable,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modalItem.value.salary_payable) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(CommonInput, {
                label: "Bonus",
                modelValue: modalItem.value.bonus_total,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modalItem.value.bonus_total) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(CommonInput, {
                label: "Advance",
                modelValue: modalItem.value.advance_paid_total,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modalItem.value.advance_paid_total) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(CommonButton, {
                  loading: modalLoading.value,
                  type: "outline",
                  label: "Cancel",
                  onClicked: closeModal
                }, null, 8, ["loading"]),
                _createVNode(CommonButton, {
                  loading: modalLoading.value,
                  type: "primary",
                  label: "Save",
                  onClick: saveSalary
                }, null, 8, ["loading"])
              ])
            ]))
          : _createCommentVNode("", true),
        (activeTab.value == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              (absentDays.value.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(absentDays.value, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(CommonInput, {
                            modelValue: item.off_date,
                            "onUpdate:modelValue": ($event: any) => ((item.off_date) = $event),
                            label: "Absent day",
                            mask: "####-##-##",
                            disabled: item.id
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _createElementVNode("div", {
                          class: "icon",
                          onClick: ($event: any) => (deleteAbsentDay(index, item))
                        }, [
                          _createVNode(_unref(Trash01), { size: 16 })
                        ], 8, _hoisted_40)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(CommonInput, {
                          modelValue: item.comment,
                          "onUpdate:modelValue": ($event: any) => ((item.comment) = $event),
                          multiline: "",
                          label: "Comment"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(CommonButton, {
                  type: "outline",
                  loading: modalLoading.value,
                  label: "Add off",
                  prepend: "",
                  prependIcon: _unref(Plus),
                  onClicked: addExtraOff
                }, null, 8, ["loading", "prependIcon"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(CommonButton, {
                  loading: modalLoading.value,
                  type: "secondary",
                  label: "Cancel",
                  onClicked: closeModal
                }, null, 8, ["loading"]),
                _createVNode(CommonButton, {
                  loading: modalLoading.value,
                  type: "primary",
                  label: "Save",
                  onClick: saveAbsent
                }, null, 8, ["loading"])
              ])
            ]))
          : _createCommentVNode("", true),
        (activeTab.value == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "action__label" }, "Timeliness", -1)),
                _createElementVNode("div", _hoisted_46, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                    return _createElementVNode("span", {
                      class: "star",
                      key: star,
                      onClick: ($event: any) => (setTimelinessScore(star))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ filled: star <= timeliness_score.value })
                      }, "★", 2)
                    ], 8, _hoisted_47)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "action__label" }, "Coverage", -1)),
                _createElementVNode("div", _hoisted_49, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                    return _createElementVNode("span", {
                      class: "star",
                      key: star,
                      onClick: ($event: any) => (setCoverageScore(star))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ filled: star <= coverage_score.value })
                      }, "★", 2)
                    ], 8, _hoisted_50)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "action__label" }, "Team", -1)),
                _createElementVNode("div", _hoisted_52, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                    return _createElementVNode("span", {
                      class: "star",
                      key: star,
                      onClick: ($event: any) => (setTeamScore(star))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ filled: star <= team_score.value })
                      }, "★", 2)
                    ], 8, _hoisted_53)
                  }), 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "action__label" }, "No shows", -1)),
                _createElementVNode("div", _hoisted_55, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                    return _createElementVNode("span", {
                      class: "star",
                      key: star,
                      onClick: ($event: any) => (setNoShowsScore(star))
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ filled: star <= no_shows_score.value })
                      }, "★", 2)
                    ], 8, _hoisted_56)
                  }), 64))
                ])
              ]),
              _createVNode(CommonInput, {
                multiline: "",
                label: "Comment",
                modelValue: ratingComment.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ratingComment).value = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(CommonButton, {
                  loading: modalLoading.value,
                  type: "outline",
                  label: "Cancel",
                  onClicked: closeModal
                }, null, 8, ["loading"]),
                _createVNode(CommonButton, {
                  loading: modalLoading.value,
                  type: "primary",
                  label: "Save",
                  onClick: saveRating
                }, null, 8, ["loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: isAdvanceModalVisible.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isAdvanceModalVisible).value = $event)),
      width: "1000px",
      title: "Advance requests",
      onClose: closeAdvanceModal
    }, {
      default: _withCtx(() => [
        _createVNode(CommonTable, {
          headers: _unref(managementStore).advanceRequestHeaders,
          loading: advanceModalLoading.value,
          items: advanceModalItems.value
        }, {
          id: _withCtx(({ index }) => [
            _createElementVNode("span", null, _toDisplayString(index + 1), 1)
          ]),
          created_time: _withCtx(({ item }) => [
            _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.created_time) || "-"), 1)
          ]),
          actions: _withCtx(({ item }) => [
            _createElementVNode("div", _hoisted_58, [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "action__item reject",
                onClick: ($event: any) => (rejectRequest(item))
              }, [
                _createVNode(_unref(XClose), { size: 18 })
              ], 8, _hoisted_59)), [
                [_directive_tooltip, {
                content: 'Reject',
                html: true,
              }]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "action__item approve",
                onClick: ($event: any) => (approveRequest(item))
              }, [
                _createVNode(_unref(Check), { size: 18 })
              ], 8, _hoisted_60)), [
                [_directive_tooltip, {
                content: 'Approve',
                html: true,
              }]
              ])
            ])
          ]),
          _: 1
        }, 8, ["headers", "loading", "items"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})